export default {
  model: null,
  nowOptions: [],
  userId: '',
  id: '',
  now: 1,
  memo: '',
  isEdit: false
}
